<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="w-full h-full bg-a-egg-f5ebdc text-a-brown-502314 lg:rounded-20 lg:px-14">
                    <div class="font-bold text-center py-4 lg:text-18">Details</div>
                    <div class="absolute top-4 right-4 flex">
                        <img class="ml-auto mr-0" @click="clickCancel()" src="@/assets/icon/ic-close-brown.svg" />
                    </div>
                    <TopBar headerName="Store" @click="clickCancel()"></TopBar>
                    <div class="text-a-brown-502314 text-14 p-4" v-if="branch">
                        <div class="border-b border-a-brown-e1d2bc">
                            <div class="text-18 font-bold pb-4">{{getName()}}</div>
                            <div class="pb-4">{{getAddress()}}</div>
                            <div class="flex pb-4">
                                <div class="">{{FilterNumberDecimalFormat(getKM(),1)}} {{lbl.store.km}}</div>
                                <div class="ml-2 mr-auto text-a-red-d62300 underline" @click="getDirection()">{{lbl.store.get_direction}}</div>
                            </div>
                        </div>
                        <div class="border-b border-a-brown-e1d2bc py-4">
                            <div class="flex">
                                <div class="ml-0 mr-auto my-auto">{{lbl.store.tel}} {{branch.contactNumber.mobile_number}}</div>
                                <a :href="'tel:'+ branch.contactNumber.mobile_number" class="mr-0 ml-auto bg-a-red-d62300 text-white font-bold py-2 px-4 rounded-full">{{lbl.store.call_now}}</a>
                            </div>
                        </div>
                        <div class="py-4">
                            <div class="font-bold pb-2">{{lbl.store.service}}</div>
                            <div v-for="(service, index) in branch.services" 
                                :key="index"
                                class="flex py-1">
                                <img class="h-6 mr-4" :src="getPartService(service)" />
                                <div class="my-auto">{{service.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
// import DatetimeHelper from "@/helper/DatetimeHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";

// import WhiteButton from "@/components/Button/WhiteButton.vue";


export default {
    name: "StoreDetailModal",
    mixins: [LocaleMixin],
    components: {
        TopBar,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            
            title: '',
            message: '',
            branch: null,
            currentLocation: null,

            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.branch = config.branch;
            this.currentLocation = config.currentLocation;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            
            console.log(this.branch);

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        getName: function() {
            if (this.localeCode == 1033) {
                return this.branch.nameEN;
            } else {
                return this.branch.name;
            }
        },
        getAddress: function() {
            if (this.localeCode == 1033) {
                return this.branch.addressEN;
            } else {
                return this.branch.address;
            }
        },
        getKM: function() {
            return this.branch.distance / 1000;
        },
        getPartService: function(service) {
            let url = ConfigManager.getBlobUrl() + "/agencylocationservices/" + ConfigManager.getAppId() + "/_" + service.id;
            return url;
        },
        getDirection: function() {
            let current = this.currentLocation.lat + ',' + this.currentLocation.lng;
            let destination = this.branch.location.latitude + ',' + this.branch.location.longitude;
            window.open('https://www.google.com/maps/dir/' + current + '/' + destination, '_blank');
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/text.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        
        .modal-content {
            width: 100%;
            min-height: 100vh;
            @include min-desktop {
                width: 550px;
                min-height: 0;
            }
            
        }
        
        .campaign-name {
            @extend %ellipsis-2;
            max-width: 75%;
            max-height: 34px;
        }
    }
</style>
